import * as React from "react";
import {Box} from "@chakra-ui/react";
import {useMemo, useRef, useState} from "react";

export default function PreviewTooltip({data,attribs,children}){

    const newData = (data && data[0] && data[0].seo) ? data[0].seo : null

    const useHover = () => {
        const [hovered, setHovered] = useState();

        const eventHandlers = useMemo(() => ({
            onMouseOver() {
                setHovered(true);
                const element = elementRef.current;
                if (element) {
                    const { top } = element.getBoundingClientRect();
                    const windowHeight = window.innerHeight;
                    if (top > windowHeight / 2) {
                        setIsBelowHalf('aTooltip--below');
                    } else {
                        setIsBelowHalf('aTooltip--above');
                    }
                }
                },
            onMouseOut() { setHovered(false); }
        }), []);

        return [hovered, eventHandlers];
    }

    const elementRef = useRef(null);
    const [isBelowHalf, setIsBelowHalf] = useState('aTooltip--below');

    const LinkTooltip = () => {
        const [hovered, eventHandlers] = useHover();

        return (
            <Box as={'a'} href={attribs.href}
                 title={attribs.title ?? (newData && newData.seoKeyword) ?? ''}
                 data-fast-preview-title={(newData && newData.fastPreviewTitle) ?? ''}
                 data-fast-preview-description={(newData && newData.fastPreviewDescription) ?? ''}
                 className={attribs.class ? attribs.class += isBelowHalf : isBelowHalf }
                 position={'relative'}
                 ref={elementRef}
                 {...eventHandlers}
            >
                {children[0].data}
                {hovered && newData &&
                    <Box as={'span'}
                         position={'absolute'}
                         left={'0px'}
                         width={'300px'}
                         color={'#000'}
                         className ={'aTooltip'}
                    >
                        <Box as={'span'} color={'#000'} display={'block'} zIndex='2' background={'#FFF'} border={'1px solid #EAEDF4'} boxShadow={'0 0 30px #0000001F'} fontSize={'14px'} lineHeight={'18px'} padding={'10px'}>
                            <Box as={'span'} fontWeight={'bold'}>{newData.fastPreviewTitle}</Box>
                            {newData.fastPreviewDescription && <Box as={'span'} fontWeight={'normal'}> - {newData.fastPreviewDescription}</Box>}
                        </Box>
                    </Box>
                }
            </Box>
        );
    };

    return(
        <>
            <LinkTooltip />
        </>
    )
}